import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import { Link } from "react-router-dom";
import CustomMedia from 'util/custom-media-query';
import Image from 'components/common/Image';
import logoPC1x from 'assets/images/PC/@1x/img_logo.png';
import logoPC2x from 'assets/images/PC/@2x/img_logo@2x.png';
import logoSP2x from 'assets/images/SP/@2x/img_logo@2x.png';
import logoSP3x from 'assets/images/SP/@3x/img_logo@3x.png';

const Logo = ({ className }) => (
  <div className={className}>
    <Link to="/">
      <Image
        pc1x={logoPC1x}
        pc2x={logoPC2x}
        sp2x={logoSP2x}
        sp3x={logoSP3x}
        alt="img_log"
      />
    </Link>
  </div>
);

const commonStyle = css`
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
`;

const spStyle = CustomMedia.lessThan('medium')`
`;


export default applyStyles(Logo)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Header/components/Logo.js